<template>
    <rkm-wizard
        ref="Wizard"
        :disabled-next-button="disabledNextButton"
        @finish="$emit('finish')"
    >
        <rkm-wizard-tab
            v-if="showBusca"
            title="Busca"
            icon="fas fa-search"
            :before-change="validateBusca"
        >
            <TabBusca
                ref="TabBusca"
                :form="form"
                :on-continue="() => $refs.Wizard.nextTab()"
                @searching="disabledNextButton = $event"
                @form-change="$emit('form-change', $event)"
                @select-cidadao="handleCidadaoSelected"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            title="Identificação"
            icon="fas fa-id-card-alt"
            :before-change="() => $refs.TabIdentificacao.validate()"
        >
            <TabIdentificacao
                ref="TabIdentificacao"
                :form="form"
                :model="model"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            title="Identificação da saúde"
            icon="fas fa-hospital-user"
            :before-change="() => $refs.TabIdentificacaoSaude.validate()"
        >
            <TabIdentificacaoSaude
                ref="TabIdentificacaoSaude"
                :form="form"
                :model="model"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            title="Endereço"
            icon="fas fa-map-marker-alt"
            :before-change="() => $refs.TabEndereco.validate()"
        >
            <TabEndereco
                ref="TabEndereco"
                :form="form"
                :model="model"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            title="Documentos"
            icon="fas fa-file-contract"
            :before-change="() => $refs.TabDocumentos.validate()"
        >
            <TabDocumentos
                ref="TabDocumentos"
                :form="form"
                :model="model"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            title="Questionário de saúde"
            icon="fas fa-heartbeat"
            :before-change="() => $refs.TabQuestionarioSaude.validate()"
        >
            <TabQuestionarioSaude
                ref="TabQuestionarioSaude"
                :form="form"
                :model="model"
            />
        </rkm-wizard-tab>
    </rkm-wizard>
</template>

<script>
// Components.
import TabBusca from './tabs/Busca'
import TabIdentificacao from './tabs/Identificacao'
import TabIdentificacaoSaude from './tabs/IdentificacaoSaude'
import TabEndereco from './tabs/Endereco'
import TabDocumentos from './tabs/Documentos'
import TabQuestionarioSaude from './tabs/QuestionarioSaude'

export default {
    components: {
        TabBusca,
        TabIdentificacao,
        TabIdentificacaoSaude,
        TabEndereco,
        TabDocumentos,
        TabQuestionarioSaude,
    },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    data: () => ({
        showBusca: true,
        disabledNextButton: false,
        selectedCidadao: null,
    }),
    methods: {
        validate() {

            return this.$refs.TabQuestionarioSaude.validate()
        },
        async validateBusca() {

            const valid = await this.$refs.TabBusca.validate()

            if (valid) {

                this.$emit('exit-busca', this.selectedCidadao)

                this.showBusca = false
            }

            return valid
        },
        handleCidadaoSelected(cidadao) {

            this.selectedCidadao = cidadao

            this.$refs.Wizard.nextTab()
        },
    },
}
</script>